import React from 'react';
import { Button } from './ui/button';
import { MessageCircle, Star, Users, BedDouble, Bath } from 'lucide-react';
import { villaImages, villaStats, whatsappNumber } from '../data/mockData';
import { useLanguage } from '../contexts/LanguageContext';

export const Hero = () => {
  const { t } = useLanguage();

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(t('hero.whatsapp'));
    if (window.gtag) { window.gtag('event', 'whatsapp_click', { event_category: 'engagement', event_label: 'hero' }); }
    if (typeof window.fbq === 'function') { window.fbq('track', 'Contact', { content_name: 'hero' }); }
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <section className="relative hero-section">
      <div className="hero-image-container">
        <img
          src={villaImages[0]}
          alt="Villa in Pietra - Luxury Roman-style villa in Istria"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>

      <div className="hero-content">
        <div className="max-w-4xl mx-auto text-center px-6">
          <div className="laurel-wreath-top">
            <svg width="60" height="40" viewBox="0 0 60 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 20C10 15 15 10 20 8C18 12 17 16 18 20C17 24 18 28 20 32C15 30 10 25 10 20Z" fill="currentColor" opacity="0.3"/>
              <path d="M50 20C50 15 45 10 40 8C42 12 43 16 42 20C43 24 42 28 40 32C45 30 50 25 50 20Z" fill="currentColor" opacity="0.3"/>
            </svg>
          </div>

          <h1 className="hero-title">Villa in Pietra</h1>

          <p className="hero-subtitle">{t('hero.subtitle')}</p>

          <div className="hero-features">
            <div className="hero-feature-item">
              <Star className="hero-icon" fill="currentColor" />
              <span>{t('hero.perfectRating')}</span>
            </div>
            <div className="hero-feature-divider"></div>
            <div className="hero-feature-item">
              <Users className="hero-icon" />
              <span>{t('hero.upToGuests').replace('{n}', villaStats.guests)}</span>
            </div>
            <div className="hero-feature-divider"></div>
            <div className="hero-feature-item">
              <BedDouble className="hero-icon" />
              <span>{t('hero.bedrooms').replace('{n}', villaStats.bedrooms)}</span>
            </div>
            <div className="hero-feature-divider"></div>
            <div className="hero-feature-item">
              <Bath className="hero-icon" />
              <span>{t('hero.bathrooms').replace('{n}', villaStats.bathrooms)}</span>
            </div>
          </div>

          <Button
            onClick={handleWhatsAppClick}
            className="hero-cta-button"
            size="lg"
            data-testid="hero-cta"
          >
            <MessageCircle className="mr-2 h-5 w-5" />
            {t('hero.cta')}
          </Button>
        </div>
      </div>

      <div className="scroll-indicator">
        <div className="scroll-line"></div>
      </div>
    </section>
  );
};

